import { render, staticRenderFns } from "./BatchConfirmReceipt.vue?vue&type=template&id=0b431464&"
import script from "./BatchConfirmReceipt.vue?vue&type=script&lang=js&"
export * from "./BatchConfirmReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports